<template>
  <div class="about">
    <my-navi activeIndex="19"></my-navi>
    <el-container>
      <el-header>
        <div style="display: flex; align-items: center;">
          <span style="font-weight: bold; font-size: 16px; margin-right: 20px;">BBYCA 改价工具</span>
          <el-upload
            :on-change="loadFile"
            :before-upload="fileCheck"
            :show-file-list="false"
            accept=".xlsx,.xls"
          >
            <el-button slot="trigger" size="small" type="primary">上传BBYCA库存报告</el-button>
          </el-upload>
          <el-tag v-if="filename" size="small" style="margin-left: 10px;" type="info">{{ filename }}</el-tag>
        </div>
        <el-input
          style="width: 30%; margin-left:20px"
          v-model="searchTerm"
          placeholder="输入SKU关键词搜索"
          @keypress.enter.native="performSearch"
        ></el-input>
        <el-button
          style="margin-left: 20px; width: 8%;"
          type="primary"
          @click="performSearch"
          >搜索</el-button
        >
      </el-header>
      <el-main>
        <el-card style="margin-bottom: 20px;">
          <el-descriptions :column="1" border>
            <el-descriptions-item label="操作步骤">
              <ol>
                <li><strong>第一步：上传报告</strong> — 点击"上传BBYCA库存报告"按钮上传Excel格式的库存报告文件。</li>
                <li><strong>第二步：搜索商品</strong> — 在搜索框输入SKU关键词，按回车或点击"搜索"按钮，匹配SKU中包含该关键词的商品。</li>
                <li><strong>第三步：修改数据</strong> — 可执行"下架"（quantity设为0）、"补货"（quantity设为指定值）或"调价"（discount-price加上浮动价格）。</li>
                <li><strong>第四步：提交修改</strong> — 点击"提交修改"将当前搜索结果的修改记录添加到右侧列表。</li>
                <li><strong>第五步：下载文件</strong> — 在右侧列表确认无误后，点击"下载结果文件"生成修改后的Excel文件。</li>
              </ol>
            </el-descriptions-item>
            <el-descriptions-item label="功能说明">
              <ul>
                <li><strong>清空</strong> — 清空当前搜索结果，重置所有输入框。</li>
                <li><strong>下架</strong> — 将搜索结果中所有商品的quantity值设为0。</li>
                <li><strong>补货</strong> — 将搜索结果中所有商品的quantity值设为文本框中输入的数字。</li>
                <li><strong>调价</strong> — 将搜索结果中所有商品的discount-price值加上文本框中输入的浮动价格。</li>
                <li><strong>提交修改</strong> — 将左侧搜索结果的修改记录添加到右侧列表，准备导出。</li>
                <li><strong>下载结果文件</strong> — 将修改后的Excel文件保存到本地。</li>
              </ul>
            </el-descriptions-item>
            <el-descriptions-item label="基准价格计算器">
              <div style="display: flex; align-items: center;">
                <el-input
                  style="width: 200px; margin-right: 10px;"
                  v-model="upcInput"
                  placeholder="输入UPC"
                  @keypress.enter.native="fetchUpcInfo"
                ></el-input>
                <el-button type="primary" @click="fetchUpcInfo">查询</el-button>
              </div>
              <div v-if="upcInfo" style="margin-top: 10px;">
                <p><strong>标准价（standard_price）：</strong>{{ upcInfo.standard_price || '-' }}</p>
                <p><strong>内存（computer_memory_size）：</strong>{{ upcInfo.computer_memory_size ? upcInfo.computer_memory_size + 'GB' : '-' }}</p>
                <p><strong>硬盘（hard_disk_size）：</strong>{{ upcInfo.hard_disk_size ? upcInfo.hard_disk_size + 'GB' : '-' }}</p>
                <p><strong>CA基准价格：</strong><span style="color: red; font-weight: bold;">{{ caBasePrice }}</span>（计算公式：(standard_price + 10) × 1.42）</p>
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </el-card>
        <el-row type="flex" justify="space-around">
          <el-col :span="11">
            <el-row
              type="flex"
              justify="space-between"
              style="padding-bottom: 20px;"
            >
              <div>
                <el-button @click="clearSerchresult">清空</el-button>
                <el-button style="margin-left: 10px;" @click="outOfStock()"
                  >下架</el-button
                >
                <el-input
                  style="width: 100px; margin-left: 10px;"
                  v-model="restockQuantity"
                  placeholder="补货数量"
                ></el-input>
                <el-button style="margin-left: 10px;" @click="restock()"
                  >补货</el-button
                >
              </div>
              <div>
                <el-input
                  style="width: 150px; margin-left: 10px;"
                  v-model="priceFlow"
                  placeholder="浮动价格"
                  @keypress.enter.native="priceFlowAction"
                ></el-input>
                <el-button
                  style="margin-left: 10px;"
                  @click="priceFlowAction"
                  >调价</el-button
                >
              </div>
              <div>
                <el-button type="primary" @click="submitChanges">提交修改</el-button>
              </div>
            </el-row>
            <el-table
              :data="serchData"
              border
              style="width: 100%; font-size: 12px;"
              :height="500"
              :row-class-name="getRowClass"
            >
              <el-table-column label="sku" prop="sku" width="200px">
                <template slot-scope="scope">
                  <span
                    style="cursor: pointer;"
                    @click="fillSearchTerm(scope.row.sku)"
                    >{{ scope.row.sku }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="price" prop="price" width="100px">
                <template slot-scope="scope">
                  <span
                    :style="{
                      color: scope.row.priceChanged ? 'red' : 'black',
                      fontWeight: scope.row.priceChanged ? 'bold' : 'normal'
                    }"
                    >{{ scope.row.price }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="quantity" prop="quantity" width="100px">
                <template slot-scope="scope">
                  <span
                    :style="{
                      color: scope.row.quantityChanged ? 'red' : 'black',
                      fontWeight: scope.row.quantityChanged ? 'bold' : 'normal'
                    }"
                    >{{ scope.row.quantity }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="discount-price" prop="discount-price" width="120px">
                <template slot-scope="scope">
                  <span
                    :style="{
                      color: scope.row.discountPriceChanged ? 'red' : 'black',
                      fontWeight: scope.row.discountPriceChanged ? 'bold' : 'normal'
                    }"
                    >{{ scope.row['discount-price'] }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="操作" width="80px">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" @click="removeFromSearch(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="11">
            <el-row
              type="flex"
              justify="space-between"
              style="padding-bottom: 20px;"
            >
              <div>
                <span style="font-weight: bold;">修改记录（共{{ finalData.length }}条）</span>
              </div>
              <div>
                <el-button
                  style="margin-left: 10px;"
                  :disabled="history.length === 0"
                  @click="undo"
                  >撤销</el-button
                >
                <el-button
                  type="primary"
                  style="margin-left: 10px;"
                  @click="downloadExcel"
                  >下载结果文件</el-button
                >
              </div>
            </el-row>
            <el-table
              :data="finalData"
              border
              style="width: 100%; font-size: 12px;"
              :height="500"
            >
              <el-table-column label="sku" prop="sku" width="200px"></el-table-column>
              <el-table-column label="price" prop="price" width="100px"></el-table-column>
              <el-table-column label="quantity" prop="quantity" width="100px"></el-table-column>
              <el-table-column label="discount-price" prop="discount-price" width="120px"></el-table-column>
              <el-table-column label="操作" width="80px">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" @click="removeFromFinal(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import axios from "axios";
export default {
  name: "BBYCAChangePrice",
  data() {
    return {
      fileContent: null,
      searchTerm: "",
      serchData: [],
      finalData: [],
      history: [],
      priceFlow: "",
      restockQuantity: "",
      filename: "",
      originalData: [],
      originalWorkbook: null,
      upcInput: "",
      upcInfo: null,
      caBasePrice: ""
    };
  },
  methods: {
    fillSearchTerm(sku) {
      this.searchTerm = sku;
    },
    loadFile(file) {
      const reader = new FileReader();
      reader.onload = e => {
        const data = new Uint8Array(e.target.result);
        this.originalWorkbook = XLSX.read(data, { type: 'array' });
        const sheetName = this.originalWorkbook.SheetNames[0];
        const worksheet = this.originalWorkbook.Sheets[sheetName];
        this.originalData = XLSX.utils.sheet_to_json(worksheet);
        this.filename = file.raw.name;
        this.$message.success("文件加载成功，共 " + this.originalData.length + " 条记录");
      };
      reader.readAsArrayBuffer(file.raw);
    },
    fileCheck(file) {
      const ext = file.name.split(".").pop().toLowerCase();
      if (ext !== "xlsx" && ext !== "xls") {
        this.$message.warning("只能上传Excel文件（.xlsx或.xls）");
        return false;
      }
      return false;
    },
    performSearch() {
      if (!this.originalData || this.originalData.length === 0) {
        this.$message.warning("请先上传库存报告");
        return;
      }
      const searchTerm = this.searchTerm.toLowerCase().trim();
      if (!searchTerm) {
        this.$message.warning("请输入搜索关键词");
        return;
      }
      this.serchData = this.originalData
        .filter(item => item.sku && item.sku.toLowerCase().includes(searchTerm))
        .map(item => ({
          ...item,
          quantityChanged: false,
          priceChanged: false,
          discountPriceChanged: false
        }));
      this.$message.success("搜索完成，共找到 " + this.serchData.length + " 条记录");
    },
    clearSerchresult() {
      this.serchData = [];
      this.priceFlow = "";
      this.restockQuantity = "";
    },
    outOfStock() {
      this.serchData.forEach(item => {
        item.quantity = 0;
        item.quantityChanged = true;
      });
      this.$message.success("已将所有商品下架（quantity=0）");
    },
    restock() {
      const qty = parseInt(this.restockQuantity);
      if (isNaN(qty) || qty < 0) {
        this.$message.warning("请输入有效的补货数量");
        return;
      }
      this.serchData.forEach(item => {
        item.quantity = qty;
        item.quantityChanged = true;
      });
      this.$message.success("已将所有商品补货为 " + qty);
    },
    priceFlowAction() {
      const flow = parseFloat(this.priceFlow);
      if (isNaN(flow)) {
        this.$message.warning("请输入有效的浮动价格");
        return;
      }
      this.serchData.forEach(item => {
        const currentPrice = parseFloat(item.price) || 0;
        item.price = (currentPrice + flow).toFixed(2);
        item.priceChanged = true;
        const currentDiscountPrice = parseFloat(item['discount-price']) || 0;
        item['discount-price'] = (currentDiscountPrice + flow).toFixed(2);
        item.discountPriceChanged = true;
      });
      this.$message.success("已将所有商品的price和discount-price调整 +" + flow);
    },
    submitChanges() {
      if (this.serchData.length === 0) {
        this.$message.warning("请先搜索到结果");
        return;
      }
      const hasChanges = this.serchData.some(item => item.quantityChanged || item.priceChanged || item.discountPriceChanged);
      if (!hasChanges) {
        this.$message.warning("请先对搜索结果进行修改");
        return;
      }
      // 保存当前状态到历史记录
      this.history.push(JSON.parse(JSON.stringify(this.finalData)));
      this.serchData.forEach(item => {
        const existingIndex = this.finalData.findIndex(e => e.sku === item.sku);
        if (existingIndex > -1) {
          this.finalData[existingIndex] = { ...item };
        } else {
          this.finalData.push({ ...item });
        }
      });
      this.$message.success("已提交 " + this.serchData.length + " 条修改记录");
      this.clearSerchresult();
    },
    removeFromFinal(index) {
      this.finalData.splice(index, 1);
      this.$message.success("已删除该条记录");
    },
    undo() {
      if (this.history.length === 0) {
        this.$message.warning("没有可撤销的操作");
        return;
      }
      this.finalData = this.history.pop();
      this.$message.success("已撤销上一次提交");
    },
    removeFromSearch(index) {
      this.serchData.splice(index, 1);
      this.$message.success("已删除该行，该行不会进入提交记录");
    },
    downloadExcel() {
      if (this.finalData.length === 0) {
        this.$message.warning("请先提交修改记录");
        return;
      }
      if (!this.originalWorkbook) {
        this.$message.warning("请先上传原始库存报告");
        return;
      }
      
      // 复制原始workbook，避免修改源文件
      const wb = JSON.parse(JSON.stringify(this.originalWorkbook));
      const sheetName = wb.SheetNames[0];
      const ws = wb.Sheets[sheetName];
      
      // 获取所有单元格地址
      const range = XLSX.utils.decode_range(ws['!ref']);
      let skuColIndex = -1;
      let quantityColIndex = -1;
      let discountPriceColIndex = -1;
      let priceColIndex = -1;
      
      // 遍历第一行（表头）找到列索引
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: range.s.r, c: col });
        const cell = ws[cellAddress];
        if (cell && cell.v) {
          const header = cell.v.toString().toLowerCase().trim();
          if (header === 'sku') {
            skuColIndex = col;
          } else if (header === 'quantity') {
            quantityColIndex = col;
          } else if (header === 'discount-price') {
            discountPriceColIndex = col;
          } else if (header === 'price') {
            priceColIndex = col;
          }
        }
      }
      
      if (skuColIndex === -1) {
        this.$message.error("未找到sku列");
        return;
      }
      
      // 创建sku到数据的映射
      const finalMap = {};
      this.finalData.forEach(item => {
        finalMap[item.sku] = item;
      });
      
      // 遍历数据行，修改对应单元格
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        const skuCellAddress = XLSX.utils.encode_cell({ r: row, c: skuColIndex });
        const skuCell = ws[skuCellAddress];
        
        if (skuCell && skuCell.v) {
          const sku = skuCell.v.toString();
          const finalItem = finalMap[sku];
          
          if (finalItem) {
            // 修改quantity
            if (quantityColIndex !== -1) {
              const qtyCellAddress = XLSX.utils.encode_cell({ r: row, c: quantityColIndex });
              ws[qtyCellAddress] = { v: finalItem.quantity };
            }
            // 修改price
            if (priceColIndex !== -1) {
              const priceCellAddress = XLSX.utils.encode_cell({ r: row, c: priceColIndex });
              ws[priceCellAddress] = { v: parseFloat(finalItem.price) };
            }
            // 修改discount-price
            if (discountPriceColIndex !== -1) {
              const discountCellAddress = XLSX.utils.encode_cell({ r: row, c: discountPriceColIndex });
              ws[discountCellAddress] = { v: parseFloat(finalItem['discount-price']) };
            }
          }
        }
      }
      
      const fileName = `BBYCA_Change_Price_${new Date().toISOString().split("T")[0]}.xlsx`;
      XLSX.writeFile(wb, fileName);
      this.$message.success("文件下载成功");
    },
    getRowClass({ row, rowIndex }) {
      if (row.quantityChanged || row.priceChanged || row.discountPriceChanged) {
        return "highlight-row";
      }
      return "";
    },
    async fetchUpcInfo() {
      const upc = this.upcInput.trim();
      if (!upc) {
        this.$message.warning("请输入UPC");
        return;
      }
      try {
        const response = await axios.get(`https://dev.admin.amz.luyantech.com/api/upc/${upc}`);
        
        if (response.code === 0 && response.data) {
          this.upcInfo = response.data;
          // 处理硬盘大小，如果小于64，则单位是TB，转换为GB
          if (this.upcInfo.hard_disk_size && typeof this.upcInfo.hard_disk_size === 'number' && this.upcInfo.hard_disk_size < 64) {
            this.upcInfo.hard_disk_size *= 1000;
          }
          // 计算CA基准价格
          if (this.upcInfo.standard_price) {
            const standardPrice = parseFloat(this.upcInfo.standard_price);
            this.caBasePrice = ((standardPrice + 10) * 1.42).toFixed(2);
          } else {
            this.caBasePrice = "";
          }
        } else {
          this.$message.error("查询UPC信息失败：" + (response.message || "未找到相关数据"));
          this.upcInfo = null;
          this.caBasePrice = "";
        }
      } catch (error) {
        this.$message.error("查询UPC信息失败：" + (error.message || "未知错误"));
        this.upcInfo = null;
        this.caBasePrice = "";
      }
    }
  }
};
</script>

<style scoped>
.highlight-row {
  background-color: #fef0f0 !important;
}
</style>
